import {
  Array,
  Boolean,
  Intersect,
  Number,
  Record,
  Static,
  String,
} from "runtypes";
import { ISport } from "./ISport";
import { IUser } from "./IUser";
const CoachBaseRuntype = Record({
  active: Boolean,
  name: String,
  schoolId: Number,
});

// DATA
export const CoachDataRuntype = Intersect(
  CoachBaseRuntype,
  Record({
    sports: Array(Number),
  })
);

export interface ICoachData extends Static<typeof CoachDataRuntype> {}

// Norm
export const CoachRuntype = Intersect(
  CoachBaseRuntype,
  Record({
    id: Number,
  })
);

export interface ICoach extends Static<typeof CoachRuntype> {
  sports: ISport[];
  user?: IUser;
  coachType?: string;
}



// WEBPACK FOOTER //
// ./src/services/ICoach.ts